
	import ModeloUpdate from '@/views/paginas/sigap/modelos/ModeloUpdate.vue';   
    import { Options   } from "vue-class-component"; 
    import {  Configuracao } from "./Configuracao"; 
	import $ from "jquery"   
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    import { PerfilConfig } from "@/core/config/PerfisConfig";
	  
    @Options({
        name: "ConfiguracaoEdicao",
        components: {   },  
        emits: [  'update-configuracao-alterado'],  
    }) 
    export default class ConfiguracaoEdicao extends ModeloUpdate {
          
        public model: any  = null ;  
        
        created() {  
            this.campos =  Configuracao.campos();   
        }
        
        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ] ,  this.perfis); 
        }
        
        get hasPermissaoAdmin( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin   ] ,  this.perfis); 
        }

        public modeloAlterado(){   
            this.formulario = {}
            if(this.modelo){  
                this.service.getModel(this.modelo.id) 
                .then(response => {   
                    this.model = JSON.parse(JSON.stringify( response ));    
                    this.formulario = JSON.parse(JSON.stringify( response ));    
                })
                .catch(error => {
                    this.formulario = { };  
                });   
            } 
        }
        
        
        public getdados(){  
            if( !this.hasPermissaoAdmin ){
                this.formulario.valor = this.model.valor ;
            }
            let dados = JSON.parse(JSON.stringify(this.formulario)); 
            return dados;
        }

        public sucesso(){  
            this.$emit("update-configuracao-alterado", null);     
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        }
        
    } 
